//components
import {DismissablePillButton, FilterStyleButton, IconLibrary, ReactCalendar, ThriveIcon} from "thrive-components"

//hook
import UseDateFilter from './DateFilter.hooks';



const DateFilter = () => {
    const {containerRef, filterButtonText, filterAriaLabel, onClickFilterButton, clearDateButtonText, showClearDatesButton, clearDateAriaLabel, onClickClearDates, showCalendar, filterDates, setFilterDates} = UseDateFilter();

    return (
        <div className='editor-activity-feed-filter' ref={containerRef}>
            {showClearDatesButton &&
                <DismissablePillButton 
                    className='clear-dates-button'
                    content={clearDateButtonText}
                    ariaLabel={clearDateAriaLabel}
                    onButtonClick={onClickClearDates}
                /> 
            }

            <span className="calendar-wrapper">
                <FilterStyleButton 
                    ariaLabel={filterAriaLabel} 
                    className='filter-button date-filter' 
                    onButtonClick={onClickFilterButton}
                    content={
                        <span>
                            {filterButtonText}
                            <ThriveIcon iconName={IconLibrary.CALENDAR} sizeInPx='13' color='var(--thriveSky)'/> 
                        </span>
                    } 
                />

                {showCalendar && 
                    <ReactCalendar 
                        selectedDates={filterDates} 
                        setSelectedDates={setFilterDates} 
                        isSelectPastOnly 
                    /> 
                }  
            </span>
        </div>
    );
};
export default DateFilter